export default {
  "Studies available": "Études disponibles",
  "Studies limit about":
    "Le nombre d'études pouvant être traitées est limité. Contactez votre responsable ou sales@3opinion.ai pour augmenter cette limite.",
  "Studies limit reached":
    "La limite d'études a été dépassée. Contactez votre responsable ou sales@3opinion.ai pour augmenter la limite.",
  "Wait for upload": "Attendez que le téléchargement en cours soit terminé",
  Upload: "Télécharger",
  directory: "Télécharger le dossier",
  zip: "Télécharger des fichiers",
  gender: "Sexe, âge",
  Name: "Description",
  Status: "Résultat de l'IA",
  studyDate: "Date d'étude",
  uploadDate: "Date de téléchargement",
  "Dicom count": "Instances",
  Action: "Action",
  Delete: "Supprimer",
  "Delete confirm": "Êtes-vous sûr de vouloir supprimer l’étude ?",
  "Delete confirm about":
    "Lors de la suppression, la limite de traitement de la recherche ne changera pas",
  "No studies": "Aucune étude n'est encore téléchargée",
  Search: "Trouver",
  Cancel: "Réinitialiser",
  "Study status none": "Pas commencé",
  "Study status process": "Traitement",
  "Study status not_found": "Normale",
  "Study status found": "Anormal",
  Wait: "En attendant",
  "Zip processed": "Compression",
  Done: "Fait",
  "Success upload":
    "Fichiers téléchargés. Attendez l'actualisation de la liste d'études.",
  "Upload error": "Serveur indisponible, réessayez plus tard",
  "Reach files size":
    "Téléchargement impossible. Poids total autorisé des fichiers dépassé.",
  "Upload process": "Téléchargement",
  Yes: "Oui",
  No: "Non",
  "Study in queue": "File d'attente",
  "Study in proccess": "Traitement",
  "Study not found": "Pathologie non trouvée",
  "Study found": "Pathologie trouvée",
  "Study error": "Erreur",
  "Study error about": "Erreur de téléchargement, réessayez plus tard",
  patientID: "Identifiant du patient",
  male_short: "M",
  female_short: "F",
  "Wait for anonimization": "Anonymisation",
  "Wait for loading": "Téléchargement",
  "Studies title": "Liste d'études | «Third Opinion»",
  "Error upload":
    "Les extensions des fichiers téléchargés ne répondent pas aux exigences",
  undefined__error:
    "Les extensions des fichiers téléchargés ne répondent pas aux exigences",
  good: "D'accord",
  step0:
    "Vous pouvez télécharger un dossier avec des études, il sera anonymisé et traité avec l'IA",
  step1:
    "Vos études sont en cours de téléchargement. Cela peut prendre quelques minutes. <br><br> Le téléchargement s'effectue en arrière-plan. Vous pouvez consulter d'autres études pendant ce temps.",
  step2:
    "La série traitée par l'IA apparaîtra ici. <br><br> Le traitement peut prendre quelques minutes, car il s'exécute en arrière-plan. Vous pouvez consulter d'autres études pendant ce temps.",
  "Demo Upload text":
    "Seuls les utilisateurs vérifiés peuvent importer leurs études",
  Register: "Inscription",
  "Demo Banner Text":
    "Créez un compte et traitez 10 de vos «Third Opinion» gratuitement",
  Okay: "D'accord",
  "Mobile Notification":
    "Le site Web est optimisé pour fonctionner sur le navigateur Chrome de bureau",
  "Studies limit Demo about":
    "Seuls les utilisateurs vérifiés peuvent importer leurs études",
  "Dicom count v2": "Instances",
  prev: "Précédent",
  next: "Suivant",
  "Files select": "Fichiers sélectionnés",
  "Access files": "Adapté aux exigences de service",
  "Access files about":
    "Ils sont téléchargés sur le serveur pour une analyse par l'IA",
  "Skip files": "Ne convient pas",
  "Tags values": "Mots-clés",
  "Skip files about": "Ne répondent pas aux exigences de service",
  Check: "Vérifier",
  "Status short": "Statut",
  TagError: {
    tail: "<br><br> Choisissez une autre étude",
    not_exist: "<TAG> non trouvé",
    some_error:
      "<TAG> avec <TAG_VALUE> ne répond pas aux exigences de service <RULES>",
    PatientsAge: "Le patient a moins de 18 ans",
    Modality: "Modalité",
    SliceThickness: "Épaisseur de la tranche",
    BodyPartExamined: "BodyPartExamined",
    StudyInstanceUID: "StudyInstanceUID",
    SeriesInstanceUID: "SeriesInstanceUID",
  },
};
